import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * What a tab's list is, and what one of its rows means.
 *
 * Sits at the top of the list's card rather than above the totals: the figures
 * are what a reader came for, and this tells them what they are looking at on
 * the way down to the rows it describes. Every tab names itself exactly once —
 * the tab strip and the breadcrumb are navigation, not the page's heading, and
 * a list with no heading at all leaves a reader nothing to land on.
 */
export function InvoiceTrackingListHeading({
  title,
  children,
}: {
  title: string;
  /** One line on what a row is. Anything longer belongs in the docs. */
  children?: ReactNode;
}) {
  return (
    <Box>
      <Typography component="h1" variant="h5" sx={{ m: 0 }}>
        {title}
      </Typography>
      {children ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {children}
        </Typography>
      ) : null}
    </Box>
  );
}
